import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { g_logistikCart } from '@chancenlogistik/client/globalSubjects.js';
import { placeOrder } from '@chancenlogistik/client/helpers/place-order.js';
import { LogistikPageCheckout } from '@chancenlogistik/client/pages/logistik-page-checkout.js';
import { LogistikRoutes } from '@chancenlogistik/client/routes.js';
import { LogistikCart } from '@chancenwerk/db/LogistikCart.js';
import type { LogistikOrderShippingDetails } from '@chancenwerk/db/LogistikOrder.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import '../components/hefte-component-shipping-details.js';
import { activeToken, currentUserHasRestrictedAccess } from '../globalSubjects.js';

/**
 * @element hefte-page-checkout
 */
@customElement('hefte-page-checkout')
export class HeftePageCheckout extends LogistikPageCheckout {
  @state() protected readonly _activeToken = new RXController(this, activeToken);
  @state() protected readonly _restrictedAccess = currentUserHasRestrictedAccess(this);

  protected override async _handleFormSuccess(shippingDetails: LogistikOrderShippingDetails) {
    try {
      await placeOrder(g_logistikCart.value.items, shippingDetails, {
        isExpress: this._isExpress,
        token: this._restrictedAccess.value ? +this._activeToken.value : undefined,
        studentCount: g_logistikCart.value.studentCount!,
      });
    } catch (err: any) {
      this._handleError(err.message);
      return;
    }
    g_logistikCart.next(new LogistikCart({}));
    goTo(LogistikRoutes.orderSuccess);
  }

  protected override _shippingDetailsComponent() {
    return html`
      <hefte-component-shipping-details
        ${ref(this._shippingDetailForm)}
        .value=${this._shippingDetails.value}
      ></hefte-component-shipping-details>
    `;
  }
}
